import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const ArrowRightIcon = ({ className }) => (
  <SvgIcon viewBox='0 0 162.891 34.868' className={className}>
    <g id='Group_2290' data-name='Group 2290' transform='translate(-738.933 -348.581)'>
      <path
        id='Path_12768'
        data-name='Path 12768'
        d='M-10811,13044h159.891'
        transform='translate(11551.433 -12678)'
        fill='none'
        stroke='#dbe7f2'
        strokeLinecap='round'
        strokeWidth='3'
      />
      <path
        id='Path_12769'
        data-name='Path 12769'
        d='M-10668.113,13216.578l15.313,15.313-15.312,15.313'
        transform='translate(11553.124 -12865.876)'
        fill='none'
        stroke='#dbe7f2'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
    </g>
  </SvgIcon>
);

export default ArrowRightIcon;
